import { useEffect, useState } from 'react';
import { SoftphonePanel } from './softphone/SoftphonePanel';
import { SignIn } from './crm/SignIn';
import { CustomerView } from './crm/CustomerView';
import { api, Customer } from './crm/api';
import { getSession, signOut } from './crm/auth';

export function App() {
  const [authed, setAuthed] = useState<boolean | null>(null);
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [selected, setSelected] = useState<string | null>(null);
  const [popPhone, setPopPhone] = useState<string>('');

  useEffect(() => { getSession().then((s) => setAuthed(!!s && s.isValid())); }, []);
  useEffect(() => { if (authed) api.listCustomers().then(setCustomers).catch(console.error); }, [authed]);

  const onContact = async (attrs: Record<string, string>, phone: string) => {
    if (attrs.customerId) { setSelected(attrs.customerId); return; }
    const found = await api.findByPhone(phone).catch(() => []);
    if (found[0]) setSelected(found[0].id);
    else { setSelected(null); setPopPhone(phone); }
  };

  const quickCreate = async () => {
    const name = window.prompt('Customer name for ' + popPhone);
    if (!name) return;
    const c = await api.createCustomer({ name, phones: [popPhone], emails: [] });
    setCustomers((xs) => [c, ...xs]);
    setSelected(c.id);
    setPopPhone('');
  };

  if (authed === null) return null;
  if (!authed) return <SignIn onDone={() => setAuthed(true)} />;

  return (
    <div className="layout">
      <SoftphonePanel onContact={onContact} />
      <nav className="list">
        <div className="row"><strong>Customers</strong><button onClick={() => { signOut(); setAuthed(false); }}>Sign out</button></div>
        {popPhone && <div className="pop"><span>Unknown caller {popPhone}</span><button onClick={quickCreate}>Create</button></div>}
        {customers.map((c) => (
          <button key={c.id} className={c.id === selected ? 'sel' : ''} onClick={() => setSelected(c.id)}>{c.name}</button>
        ))}
      </nav>
      <main>
        {selected ? <CustomerView customerId={selected} onChanged={() => api.listCustomers().then(setCustomers)} /> : <p className="empty">Select a customer or wait for a call.</p>}
      </main>
    </div>
  );
}
